import { Navigate, Outlet, useLocation } from "react-router-dom";
import { getAdminToken, getAdminUser, isAdminRole } from "../utils/auth";

const ProtectedRoute = () => {
  const location = useLocation();
  const token = getAdminToken();
  const user = getAdminUser();

  if (!token || !user || !isAdminRole(user.role)) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
